export interface IMyScope extends ng.IScope
{
       isActive: boolean;
}

export function slideable(): ng.IDirective {
    return {
        restrict: 'C',
        scope: {
            isActive: "="
        },
        compile: (element, attr) => {

            var contents = element.html();
            element.html('<div class="slideable_content" style="margin:0 !important; padding:0 !important" >' + contents + '</div>');

            return (scope: IMyScope, element, attrs) => { 
                // default properties
                attrs.duration = (!attrs.duration) ? '.25s' : attrs.duration;
                attrs.easing = (!attrs.easing) ? 'ease-in-out' : attrs.easing;

                if (scope.isActive) {
                    element.css({
                        'overflow': 'hidden',
                        'transitionProperty': 'height',
                        'transitionDuration': attrs.duration,
                        'transitionTimingFunction': attrs.easing
                    });
                } else {
                    element.css({
                        'overflow': 'hidden',
                        'height': '0',
                        'transitionProperty': 'height',
                        'transitionDuration': attrs.duration,
                        'transitionTimingFunction': attrs.easing
                    });
                }
            };
        }
    }
}

export function slideToggle(): ng.IDirective {
    return {
        restrict: 'A',
        scope: {
            isActive: "="
        },
        link: (scope: IMyScope, element, attrs) => {
            var target, content;

            if (scope.isActive)
                element.addClass('expanded');

            element.bind('click', () => {
                if (!target) target = document.querySelector(element.attr('slide-toggle'));
                if (!content) content = target.querySelector('.slideable_content');

                if (!element.hasClass('expanded')) {
                    content.style.border = '1px solid rgba(0,0,0,0)';
                    var y = content.clientHeight;
                    content.style.border = 0;
                    target.style.height = y + 'px';
                    element.addClass('expanded');
                } else {
                    element.removeClass('expanded');
                    target.style.height = '0px';
                }
            });

        }
    }
}



/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/core/angularSlideable.ts
 **/